module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/doubt/doubt.component.css
// module id = ./src/app/doubt/doubt.component.css
// module chunks = main